export const convocatorias = [
  //  {
  //   nombre: "Ventanilla",
  //   enlace:"https://sader.hidalgo.gob.mx/CampoDigital",
  //   anio: "2026",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Ventanilla 2026",
  //       enlaceformato:"https://sader.hidalgo.gob.mx/CampoDigital",
  //     },
      
  //   ]

  // },
  {
    nombre: "Convocatoria - Entrega de Crías de Peces ",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/CriaPeces202.pdf",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1DignificarMujer.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo ",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
    ]
  },
   {
    nombre: "Lineamientos Internos Programa Estatal Raíces para el Futuro",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/LineamientosPN2026.pdf",
    anio: "Ejercicio 2026",
     formatos: [
      {
        id: "1",
        nombreformato: "",
      },
    ]
  },
   {
    nombre: "Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/ReglasOperacion2026.pdf",
    anio: "2026",
     formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización enero 2026",
      },
    ]
  },
  {
    nombre: "Convocatoria - Catástrofes Agrícolas ",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/CatastrofesAgricolas.pdf",
    anio: "2025",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo1Catastrofes.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo2Catastrofes.pdf",
      },
    ]
  },
   {
    nombre: "Convocatoria - Catástrofes Pecuarias ",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/CatastrofesPecuarias.pdf",
    anio: "2025",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo1Catastrofes.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo2Catastrofes.pdf",
      },
    ]
  },
  {
    nombre: "Reglas de Operación del Programa de Apoyo para Catástrofes Agropecuarias",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/3ReglasOperacion2025.pdf",
    anio: "2025",
     formatos: [
      {
        id: "1",
        nombreformato: "Anexo 3",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo3Catastrofes.pdf",
        
      },
    ]
  },
   {
    nombre: "Convocatoria - Reconversión productiva",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/ReconversionProductivaV2.pdf",
    anio: "2025",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A1DignificarV2.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A2FUPS.pdf",
      },
    ]
  },
  {
    nombre: "Convocatoria - Areteo",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Areteo.pdf",
    anio: "2025",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A1TransformarV2.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A2FUPS.pdf",
      },
    ]
  },
  {
    nombre: "Convocatoria - Equipamiento de Infraestructura Hidroagrícola",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/EquipamientoHidroagricola.pdf",
    anio: "2025",
     formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A1TransformarV2.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A2FUPS.pdf",
      },
    ]
  },
   {
    nombre: "Convocatoria - Equipamiento para Invernaderos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/EquipamientoInvernaderos.pdf",
    anio: "2025",
      formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A1TransformarV2.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A2FUPS.pdf",
      },
    ]
  },
   {
    nombre: "Convocatoria - Equipamiento para Productores de café",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/EquipamientoCafe.pdf",
    anio: "2025",
     formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1",
        enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A1TransformarV2.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2",
         enlaceformato:
        "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/A2FUPS.pdf",
      },
    ]
  },

   {
    nombre: "Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/2ReglasOperacion2025.pdf",
    anio: "2025",
     formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización 13 de octubre 2025",
      },
    ]
  },
  {
    nombre: "Infraestructura de uso colectivo, almacenamiento Y aprovechamiento de agua",
    enlace:
      "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Convocatoria_Infraestructura.pdf",
    anio: "2025",

  },
     {
    nombre: "Linemientos del Programa Estatal 'Raíces para el futuro'",
    enlace:
      "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Lineamientos2025.pdf",
    anio: "2025",
    formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización 26 de marzo 2025",
      },
    ]

  },
  {
    nombre: "Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/ReglasOperacion2025.pdf",
    anio: "2025",

  },
 
 

  // {
  //   nombre: "Acompañamiento Técnico",
  //   enlace:
  //     "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2024/ConvocatoriaAcompañamientoTecnico2024.pdf",
  //   anio: "2024",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "",
  //     },
  //   ]

  
  

  //CONVOCATORIAS 2025
  //  {
  //   nombre: "Equipamiento para productores de café",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/ConvocatoriaCafe2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },

  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo2.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Agregación de valor para mujeres rurales",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2025/ConvocatoriaAgregacionMujer2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 5",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo5.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Anexo 6",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo6.pdf",
  //     },
  //     {
  //       id: "3",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  //  {
  //   nombre: "Equipamiento Pecuario (Sementales)",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/ConvocatoriaSementales2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 8",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo8.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2024/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Linemientos del Programa Normal",
  //   enlace:
  //     "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/Lineamientos-Secretario-firmado.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Ultima actualización 29 de febrero 2024",
  //     },
  //   ]

  // },
  // {
  //   nombre: "Apoyo para Catástrofes Agrícolas",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/CatastrofesAgricolas2024.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1Agricola.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
    
  // },
  // {
  //   nombre: "Apoyo para Catástrofes Pecuarias",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2025/CatastrofesPecuarias2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2Pecuario.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Entrega de semilla de avena",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaAvena2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Entrega de semilla de cebada",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2025/ConvocatoriaCebada2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },

  // {
  //   nombre: "Entrega de semilla de maíz",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2025/ConvocatoriaMaiz2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Entrega de semilla de jitomate",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaJitomate2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Entrega de análisis de suelos",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaAnalisisSuelos2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Mejoramiento genético",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaMejoramientoGenetico2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Impulso a la apicultura hidalguense",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaApicultura2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },

  // {
  //   nombre: "Entrega de hijuelos de maguey",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaHijuelosMaguey2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Reconversión productiva",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2024/ConvocatoriaReconversionProductiva2024.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo1.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo.pdf",
  //     },
     
  //   ],
  // },
  // // {
  // //   nombre: "Entrega de crías de peces",
  // //   enlace:
  // //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2024/Convocatoria2024.pdf",
  // //   anio: "2024",
    
  // // },

 

  // {
  //   nombre: "Equipamiento ovino",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaEquipOvino2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },

  // {
  //   nombre: "Equipamiento Bovino",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaEquipBovino2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },

  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Equipamiento bovino leche",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/2024/ConvocatoriaEquipBovinoLeche2024.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },

  //     {
  //       id: "3",
  //       nombreformato: "Anexo de Apoyo",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/AnexoApoyo.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Equipamiento acuícola",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaEquipAcuicola2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Equipamiento agrícola.",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaEquipAgricola2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 2",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo2.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },

  // {
  //   nombre: "Fomento a la producción mediante huertos familiares",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaHuertosFamiliares2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 3",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2024/Anexo3.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2024/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  // {
  //   nombre: "Fomento a la producción con aves de doble propósito",
  //   enlace:
  //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/2025/ConvocatoriaAves2025.pdf",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 3",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo3.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Cédula Socio-económica (Anexo 4)",
  //       enlaceformato:
  //         "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Convocatorias/Anexo2025/Anexo4.pdf",
  //     },
     
  //   ],
  // },
  



  

];

export const convocatoriaHistoricos = [
  {
    "anio" : "2024",
    "descripcion" : "Disponibilidad de años anteriores",
    "trimestres" : [
        {
            "trimestre" : "Anexos Programas para Subsidios y Apoyos 2024",
            "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Zip/2024.zip"
        },
        
    ]
},
  {
    "anio" : "2023",
    "descripcion" : "Disponibilidad de años anteriores",
    "trimestres" : [
        {
            "trimestre" : "Anexos Programas para Subsidios y Apoyos 2023",
            "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2023.zip"
        },
        
    ]
},
  {
      "anio" : "2022",
      "descripcion" : "Disponibilidad de años anteriores",
      "trimestres" : [
          {
              "trimestre" : "Anexos Programas para Subsidios y Apoyos 2022",
              "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2022.zip"
          },
          
      ]
  },
  {
    "anio" : "2021",
    "descripcion" : "Disponibilidad de años anteriores",
    "trimestres" : [
        {
            "trimestre" : "Anexos Programas para Subsidios y Apoyos 2021",
            "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2021.zip"
        },
        
    ]
},
{
  "anio" : "2020",
  "descripcion" : "Disponibilidad de años anteriores",
  "trimestres" : [
      {
          "trimestre" : "Anexos Programas para Subsidios y Apoyos 2020",
          "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2020.zip"
      },
      
  ]
},
{
  "anio" : "2019",
  "descripcion" : "Disponibilidad de años anteriores",
  "trimestres" : [
      {
          "trimestre" : "Anexos Programas para Subsidios y Apoyos 2019",
          "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2019.zip"
      },
      
  ]
},
{
  "anio" : "2018",
  "descripcion" : "Disponibilidad de años anteriores",
  "trimestres" : [
      {
          "trimestre" : "Anexos Programas para Subsidios y Apoyos 2018",
          "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Convocatorias/zip/2018.zip"
      },
      
  ]
},
]

